import { FC } from 'react';
import AccordionContent from 'ui-kit/components/accordion/AccordionContent';
import { TrusteeInfo, ValidationState } from '../../types';
import TrusteeForm from './TrusteeForm';

interface TrusteeAccordionProps {
  trustee: TrusteeInfo;
  validation: ValidationState;
  index: number;
  transferorIndex: number;
  clearFieldError: (fieldPath: string) => void;
  onUpdate: (trustee: TrusteeInfo) => void;
  onDelete: () => void;
}

const TrusteeAccordion: FC<TrusteeAccordionProps> = ({
  trustee,
  validation,
  index,
  transferorIndex,
  clearFieldError,
  onUpdate,
  onDelete,
}) => {
  const handleDelete = () => {
    onDelete();
  };
  return (
    <AccordionContent
      id={trustee.id || `trustee-${index}`}
      title={`Trustee No. ${index + 1}`}
      expanded={true}
      hideSubtitle={true}
      icon="person"
      data-testid={`fincen-trustee-${transferorIndex}-${index}-accordion`}
      data-testid-edit={`fincen-trustee-${transferorIndex}-${index}-edit-button`}
      data-testid-delete={`fincen-trustee-${transferorIndex}-${index}-delete-button`}
      onDelete={index === 0 ? undefined : handleDelete}
      subtitle={[]}
    >
      <TrusteeForm
        trustee={trustee}
        transferorIndex={transferorIndex}
        trusteeIndex={index}
        validation={validation}
        onUpdate={onUpdate}
        onDelete={onDelete}
        clearFieldError={clearFieldError}
      />
    </AccordionContent>
  );
};

export default TrusteeAccordion;
